exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-669f5b32] {\n  margin: 1.5em 0 .5em;\n}\n", ""]);

// exports
